import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LegalLoginShell from 'components/LegalLoginShell';
import LegalDocument from 'legal/LegalDocument';
import termsOfService from 'legal/termsOfService';
import privacyPolicy from 'legal/privacyPolicy';

function LegalDocumentPage() {
  const location = useLocation();
  const isPrivacy = location.pathname.indexOf('/privacy') !== -1;
  const title = isPrivacy ? 'Privacy Policy' : 'Terms of Service';
  const sections = isPrivacy ? privacyPolicy : termsOfService;

  return (
    <LegalLoginShell>
      <div className="legal-accept-card legal-document-page">
        <div className="legal-accept-header">
          <h1>{title}</h1>
        </div>
        <div className="legal-document-scroll">
          <LegalDocument sections={sections} />
        </div>
        <div className="legal-accept-links">
          <Link to={isPrivacy ? '/legal/terms' : '/legal/privacy'}>
            {isPrivacy ? 'View Terms of Service' : 'View Privacy Policy'}
          </Link>
        </div>
      </div>
    </LegalLoginShell>
  );
}

export default LegalDocumentPage;
